import React from 'react';
import { Col, Row, Form, Card } from 'react-bootstrap';

const GuardiansForm = (props) => {

    const [shareAddress, setShareAddress] = React.useState(true);
    const handleShareAddressChange = (e) => { setShareAddress(e.target.checked) };

    const [formData, setFormData] = React.useState({
        address: { address: '', apartment: '', city: '', county: '', state: '', zip: '' },
        mailingAddress: { address: '', apartment: '', city: '', county: '', state: '', zip: '' }
    });
    const handleAddressChange = (e) => {
        setFormData(prevState => ({ ...prevState, address: { ...prevState.address, [e.target.getAttribute('field')]: e.target.value } }));
    }
    const handleMailingAddressChange = (e) => {
        setFormData(prevState => ({ ...prevState, mailingAddress: { ...prevState.mailingAddress, [e.target.getAttribute('field')]: e.target.value } }));
    }

    return (
        <Card className="mb-2 mt-3" border="warning">
            <Card.Header className="bg-warning">Parent or Guardian Information</Card.Header>
            <Card.Body>
                <Row>
                    <Col xl={6}>
                        <Form.Group controlId="guardianLastName">
                            <Form.Label>Guardian's Last Name *</Form.Label>
                            <Form.Control type="text" className='mb-2' required />
                        </Form.Group>
                    </Col>
                    <Col xl={4}>
                        <Form.Group controlId="guardianFirstName">
                            <Form.Label>First Name *</Form.Label>
                            <Form.Control type="text" className='mb-2' required />
                        </Form.Group>
                    </Col>
                    <Col xl={2}>
                        <Form.Group controlId="guardianMiddleName">
                            <Form.Label>Middle Name</Form.Label>
                            <Form.Control type="text" className='mb-2' />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group controlId="guardianMaritalStatus">
                            <Form.Label>Marital Status *</Form.Label>
                            <Form.Select className='mb-2' required>
                                <option hidden value="">Choose Marital Status</option>
                                <option value="single">Single</option>
                                <option value="married">Married</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="guardianLanguage">
                            <Form.Label>Language *</Form.Label>
                            <Form.Select className='mb-2' required>
                                <option hidden value="">Choose Language</option>
                                <option value="english">English</option>
                                <option value="spanish">Spanish</option>
                                <option value="other">Other</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col xl={5}>
                        <Form.Group controlId='guardianHomeAddress'>
                            <Row>
                                <Col>
                                    <Form.Label>Home Address (No P.O. Box): Street *</Form.Label>
                                </Col>
                                <Col className='text-end' style={{ marginRight: '-1em' }} >
                                    <Form.Check
                                        inline
                                        label='Same as primary applicant'
                                        type='checkbox'
                                        defaultChecked={true}
                                        onChange={handleShareAddressChange}
                                    />
                                </Col>
                            </Row>
                            <Form.Control className='mb-2' type='text' field='address' readOnly={shareAddress} value={shareAddress ? props.address.address : formData.address.address} onChange={handleAddressChange} rows={3} required />
                        </Form.Group>
                    </Col>
                    <Col xl={1}>
                        <Form.Group controlId='guardianApartment'>
                            <Form.Label>Apartment</Form.Label>
                            <Form.Control type='text' className='mb-2' field='apartment' readOnly={shareAddress} value={shareAddress ? props.address.apartment : formData.address.apartment} onChange={handleAddressChange} />
                        </Form.Group>
                    </Col>
                    <Col xl={2}>
                        <Form.Group controlId='guardianCity'>
                            <Form.Label>City *</Form.Label>
                            <Form.Control type='text' className='mb-2' field='city' value={shareAddress ? props.address.city : formData.address.city} onChange={handleAddressChange} required />
                        </Form.Group>
                    </Col>
                    <Col xl={2}>
                        <Form.Group controlId='guardianCounty'>
                            <Form.Label>County *</Form.Label>
                            <Form.Control type='text' className='mb-2' field='county' value={shareAddress ? props.address.county : formData.address.county} onChange={handleAddressChange} required />
                        </Form.Group>
                    </Col>
                    <Col xl={1}>
                        <Form.Group controlId='guardianState'>
                            <Form.Label>State *</Form.Label>
                            <Form.Control type='text' className='mb-2' field='state' value={shareAddress ? props.address.state : formData.address.state} onChange={handleAddressChange} required />
                        </Form.Group>
                    </Col>
                    <Col xl={1}>
                        <Form.Group controlId='guardianZip'>
                            <Form.Label>Zip *</Form.Label>
                            <Form.Control type='number' className='mb-2' field='zip' value={shareAddress ? props.address.zip : formData.address.zip} onChange={handleAddressChange} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()} required />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col xl={5}>
                        <Form.Group controlId='guardianMailingAddress'>
                            <Form.Label>Mailing Address (No P.O. Box): Street (if different than above)</Form.Label>
                            <Form.Control className='mb-2' type='text' field='address' value={shareAddress ? props.mailingAddress.address : formData.mailingAddress.address} onChange={handleMailingAddressChange} rows={3} />
                        </Form.Group>
                    </Col>
                    <Col xl={1}>
                        <Form.Group controlId='guardianMailingApartment'>
                            <Form.Label>Apartment</Form.Label>
                            <Form.Control type='text' className='mb-2' field='apartment' value={shareAddress ? props.mailingAddress.apartment : formData.mailingAddress.apartment} onChange={handleMailingAddressChange} />
                        </Form.Group>
                    </Col>
                    <Col xl={2}>
                        <Form.Group controlId='guardianMailingCity'>
                            <Form.Label>City</Form.Label>
                            <Form.Control type='text' className='mb-2' field='city' value={shareAddress ? props.mailingAddress.city : formData.mailingAddress.city} onChange={handleMailingAddressChange} />
                        </Form.Group>
                    </Col>
                    <Col xl={2}>
                        <Form.Group controlId='guardianMailingCounty'>
                            <Form.Label>County</Form.Label>
                            <Form.Control type='text' className='mb-2' field='county' value={shareAddress ? props.mailingAddress.county : formData.mailingAddress.county} onChange={handleMailingAddressChange} />
                        </Form.Group>
                    </Col>
                    <Col xl={1}>
                        <Form.Group controlId='guardianMailingState'>
                            <Form.Label>State</Form.Label>
                            <Form.Control type='text' className='mb-2' field='state' value={shareAddress ? props.mailingAddress.state : formData.mailingAddress.state} onChange={handleMailingAddressChange} />
                        </Form.Group>
                    </Col>
                    <Col xl={1}>
                        <Form.Group controlId='guardianMailingZip'>
                            <Form.Label>Zip</Form.Label>
                            <Form.Control type='number' className='mb-2' field='zip' value={shareAddress ? props.mailingAddress.zip : formData.mailingAddress.zip} onChange={handleMailingAddressChange} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()} />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col xl={2}>
                        <Form.Group controlId="guardianPrimaryPhone">
                            <Form.Label>Primary Phone *</Form.Label>
                            <Form.Control type="tel" className='mb-2' required />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col xl={3}>
                        <Form.Group controlId="guardianBestTimeToCall">
                            <Form.Label>Best time to call</Form.Label>
                            <Form.Select className='mb-2'>
                                <option hidden value="">Choose Best time to call</option>
                                <option value="AM">AM</option>
                                <option value="PM">PM</option>
                                <option value="Any">Any</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col xl={6}>
                        <Form.Group controlId="guardianEmail">
                            <Form.Label>Email Address</Form.Label>
                            <Form.Control type="email" className='mb-2 col' placeholder="sample.email@domain.com" />
                        </Form.Group>
                    </Col>
                    <Col xl={6}>
                        <div className="fs-xsmaller col rounded bg-warning bg-opacity-25 mt-4 p-1" >By providing my email address, I am authorizing Health First Health Plans to send any and all communications regarding this Application via secure email.</div>
                    </Col>
                </Row>
            </Card.Body>
        </Card >
    )

}
export default GuardiansForm
